export default __webpack_public_path__ + "static/media/favicon-tx.51b7ab4a.ico";